<template>
    <el-card class="SearchResultListingCard" :body-style="{ padding: '0px' }">
        <div class="row">
            <div class="col-xs-12">
                <div class="SearchResultListingCard__PropertyImage" v-if="!loading">
                    <el-carousel
                        class="card-carousel"
                        v-if="property.covers && property.covers.length > 0"
                        :autoplay="false"
                        indicator-position="none"
                    >
                        <el-carousel-item v-for="cover of property.covers" :key="cover.id" >
                            <img :src="cover" class="carousel-img" @click="showPropertyModal">
                        </el-carousel-item>
                    </el-carousel>
                    <span class="SearchResultListingCard__RegionName" :style="{ background: property.city && property.city.region && property.city.region.color ? property.city.region.color : 'grey' }" @click="toMap" v-if="property.city"><i class="fas fa-map-marker-alt"></i>{{ language === 'english' ?  property.city.name : property.city.name_jp}}</span>
                </div>
                <el-tooltip class="item" effect="light" :content="'Favorite' | language" placement="top">
                    <div class="SearchResultListingCard__PropertyFavorite">
                        <div v-if="!favoriteLoading">
                            <img :src="require('../../assets/images/jhf_fav_col.svg')" @click="favorite" class="" v-if="utils.isFavorite(property.int_property_id, $store.state.user.favoriteIds)">
                            <img :src="require('../../assets/images/jhf_fav_bw.svg')" @click="favorite" class="" v-else>
                        </div>
                        <div v-else>
                            <i class="fas fa-spinner fa-spin"></i>
                        </div>
                    </div>
                </el-tooltip>

                <span class="SearchResultListingCard__NewProperty" v-if="!loading && property.bit_new">New</span>
                <span class="SearchResultListingCard__NewProperty" v-if="!loading && property.bit_hot_top">Top</span>
                <span class="SearchResultListingCard__NewProperty" v-if="!loading && property.bit_hot_property">Hot</span>

                <div class="SearchResultListingCard__PropertyImage" style="width:100%">
                    <content-loader
                        :height="300"
                        :width="513"
                        :speed="2"
                        primaryColor="#d8d7dc"
                        secondaryColor="#ecebeb"
                        v-if="loading"
                    >
                        <rect x="0" y="0" rx="5" ry="5" width="513" height="300"/>
                    </content-loader>
                </div>

                <div class="SearchResultListingCard__TextRow" @click="showPropertyModal">
                    <span class="SearchResultListingCard__PropertyPrice" v-if="!loading && property.price > 0 && !property.bit_inquiry && !property.bit_inquiry_all">{{property.price | currency('¥',0)}}</span>
                    <span class="SearchResultListingCard__PropertyPrice" v-if="!loading && property.price === 0 || property.bit_inquiry || property.bit_inquiry_all">{{'Please Inquire' | language}}</span>

                    <content-loader
                        :height="40"
                        :width="413"
                        :speed="2"
                        primaryColor="#d8d7dc"
                        secondaryColor="#ecebeb"
                        v-if="loading">
                        <rect x="0" y="0" rx="5" ry="5" width="170" height="10" />
                        <rect x="0" y="20" rx="5" ry="5" width="170" height="10" />
                        <rect x="280" y="0" rx="5" ry="5" width="170" height="10" />
                    </content-loader>

                    <span class="SearchResultListingCard__PropertyName" v-if="!loading">{{language ==='english' ? property.str_property_name_en : property.str_property_name_jp}}</span>
                    <div class="bottom clearfix">
                        <p class="SearchResultListingCard__PropertyCity" v-if="!loading">
                            <span v-if="property.ward && property.ward.str_ku_shi_name_en">{{language ==='english' ?  property.ward.str_ku_shi_name_en : property.ward.str_ku_shi_name_jp}}</span>
                        </p>
                    </div>
                     <div class="bottom clearfix">
                        <p class="SearchResultListingCard__PropertyAttribute" v-if="!loading">
                            <strong v-if="property.room">{{language === 'english' ? property.room.str_room_type_name_en : property.room.str_room_type_name_jp}}</strong>
                            <strong v-if="property.flt_size > 0">{{property.flt_size}}m<sup>2</sup></strong>
                        </p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-xs-12 buttons">
                <el-button @click="showPropertyModal" type="text" size="mini" class="SearchResultListingCard__Button details"><i class="fas fa-info"></i>Details</el-button>
                <el-button type="text" size="mini" class="SearchResultListingCard__Button view-on-map" @click="toMap"><i class="fas fa-map-marker-alt"></i>View on Map</el-button>
            </div> -->
        </div>
    </el-card>
</template>

<script>
    import LoginModal from '../Pages/Login/Modal'
    import utils from '../../services/utilsService.js'
    import { ContentLoader } from 'vue-content-loader'
    import { mapState } from 'vuex'

    export default {
        name: "search-result-list-card",

        components: {
            ContentLoader
        },
        props: {
            property: Object,
            loading: Boolean
        },
        computed: {
            ...mapState({
                language: (state) => {
                    return state.general.language
                },
            }),
        },
        data: function() {
            return {
                isMobileDevice: utils.isMobileDevice(),
                utils: utils,
                favoriteLoading:false
            }
        },
        methods: {
            showPropertyModal() {
                this.$router.push({ name: 'Property', params: { id: this.property.int_property_id } })
            },
            beforeOpen() {
            },
            beforeClose() {
               this.$store.dispatch('property/properties',this.$route.query)
            },
            toMap() {
                const center = {
                    lat:parseFloat(this.property.int_latitude),
                    lng:parseFloat(this.property.int_longitude)
                }
                this.$store.commit('property/set_center',center);
                this.$store.commit('property/set_current_zoom',15);
            },
            favorite() {
                const that = this
                that.favoriteLoading = true
                const promise = this.$store.dispatch('property/favorite',this.property.int_property_id);
                promise.then(() => {
                    this.$store.dispatch('user/favorites')
                    const getMePromise = this.$store.dispatch('user/getFavoriteIds')
                    getMePromise
                    .finally(() => {
                        that.favoriteLoading = false
                    })
                })
                .catch(() => {
                    that.favoriteLoading = false
                    this.$modal.show(LoginModal, {
                    }, {
                        name: 'login-modal',
                        width: '100%',
                        maxWidth: 350,
                        height: 'auto',
                        adaptive: true,
                        scrollable: true,
                    }, {
                        'before-open': this.beforeOpen,
                        'before-close': this.beforeClose
                    })
                })
            }
        }
    }
</script>

<style lang="scss">
    .SearchResultListingCard {
        position: relative;
        height: 100%;
        cursor: pointer;
        transition: all 0.25s;

        &:hover {
            transform: translate(0, -2px);
        }

        .card-carousel {
            .el-carousel__item {
                display: flex;
                align-items: center;

                &.is-active {
                    z-index: 0;
                }
            }

            .carousel-img {
                display: block;
                width: 100%;
                height: auto;
            }
        }

        .row {
            height: 100%;
        }

        .el-card__body {
            height: 100%;
        }

        &__Focus {
            border-color: #2188ff;
            box-shadow: inset 0 4px 6px rgba(27, 31, 35, 0.212), 0 0 0 0.3em rgba(3, 101, 214, 0.603);
            border-radius: $border-radius;

            &:hover {
                transform: translate(0, -2px);
            }
        }

        &__ImageRow {
            height: 55%
        }

        &__TextRow {
            position: relative;
            padding: .5rem;
        }

        &__PropertyImage {
            position: relative;
        }

        .buttons {
            align-self: flex-end;
        }

        .el-button {
            width: 100%;
            margin: .5rem 0 0 0;
            margin-left: 0 !important;
            padding: .75rem;
            transition: all ease 300ms;
            border: none;
            border-top: 1px solid rgba($alternate-color, .2);
            border-radius: 0;
            color: $alternate-color!important;

            .fas {
                padding-right: .75rem;
            }

            &.details {
                border-right: .5px solid rgba($alternate-color, .2);
            }

            &.view-on-map {
            }

            &:hover, &:focus {
                color: $primary-color!important;
                border-color: $primary-color;
                i {
                    color: $primary-color;
                }
            };
        }

        &__PropertyName {

            font-weight: 700;
            text-transform: capitalize;
            font-size: 1.125rem;
            line-height: 1em;
        }

        &__PropertyAddress {
            color: gray;
            font-size: .8rem;
            text-transform: capitalize;
        }

        &__PropertyPrice {
            position: absolute;
            padding: .25rem .75rem;
            background-color: rgba(247, 247, 247, 0.9);
            color: #424242;
            font-weight: 600;
            border-radius: 3px;
            font-size: .9rem;
            top: -2.35rem;
            right: .5rem;
        }

        &__PropertyFavorite {
            position: absolute;
            top: .5rem;
            right: .5rem;
            cursor: pointer;
            width: 25px;
            height: 25px;
            text-align: center;

            img {
                width: 25px;
                height: 25px;
            }

            .fas {
                padding-right: 0;
            }
        }

        &__RegionName {
            position: absolute;
            padding: .25rem .75rem;
            border-radius: 4px;
            font-size: 0.75rem;
            color: rgb(255, 255, 255);
            font-weight: 600;
            bottom: .5rem;
            left: .5rem;

            &:hover {
                .fas {
                    transform: translateY(-2px);
                    border-bottom: 1px solid;
                    padding-bottom: 3px;
                }
            }

            .fas {
                padding-right: 0;
                margin-right: .75em;
                transition: ease-in-out .2s;
            }
        }

        &__NewProperty {
            position: absolute;
            background: rgb(187, 29, 47);
            background: linear-gradient(45deg, rgba(187, 29, 47, 1) 0%, rgba(255, 64, 86, 1) 100%);
            padding: .25rem .75rem;
            border-radius: 4px;
            font-size: 0.75rem;
            color: white;
            font-weight: 600;
            text-transform: uppercase;
            top: .5rem;
            left: .5rem;
        }

        &__PropertyIcon {}

        &__TrainInformation {
            padding: .5rem;
            border-radius: 4px;
            background-color: rgb(247, 247, 247);
            margin: .5rem .5rem .5rem 0;
        }

        &__PropertyTrainLine {
            font-size: 0.8rem;
            font-weight: 700;
            padding-bottom: .25rem
        }

        &__PropertyTrainStation {
            font-size: 0.8rem;
            font-weight: 600;
            padding-bottom: .25rem;

            &::before {
                content: '−';
                color: red;

            }
        }

        &__PropertyCity,
        &__PropertyAttribute {
            margin: 0;
            text-transform: capitalize;
            font-size: 0.9rem;
            color: rgb(136, 136, 136);
            font-weight: 400;
            display:flex;
            justify-content: space-between;
        }

        &__PropertyStationDistance {
            font-size: 0.8rem;
        }

        &__CTA {
            font-size: 0.75rem;
            text-transform: uppercase;
            font-weight: 700;
            color: #BB1D2F;
            bottom: 0.75rem;
            right: 1.3rem;

            &::after {
                content: '>';
                padding: 0 0 0 0.5rem;
            }
        }

        .image {
            width: 100%;
            display: block;
        }

        .ListingEnquiryDesktop {
            &__Container {
                position: sticky;
            }

        }
    }

    .Favourites {
        .view-on-map {
            display: none;
        }

        .details {
            width: 100%;
            border-right: none!important;
        }
    }
</style>